"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { StickyContentItem } from "./BlockStickyContentListClient";

interface StickyContentContextValue {
  activeIndex: number;
  items: StickyContentItem[];
}

const StickyContentContext = createContext<StickyContentContextValue | null>(null);

interface StickyContentProviderProps {
  children: ReactNode;
  activeIndex: number;
  items: StickyContentItem[];
}

export function StickyContentProvider({ children, activeIndex, items }: StickyContentProviderProps) {
  return <StickyContentContext.Provider value={{ activeIndex, items }}>{children}</StickyContentContext.Provider>;
}

export function useStickyContentContext() {
  const context = useContext(StickyContentContext);
  if (!context) {
    // Return safe defaults when used outside provider (e.g., standalone usage)
    return { activeIndex: 0, items: [] };
  }
  return context;
}
